import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toInteger, isEmpty } from 'lodash';

import { PATH } from '../../../../constants/path';
import directoryService from '../../../../services/directory';

import { clearFilter, filterPartnerOnCategory } from '../../../../services/filter/actions';

import { formatCategoryNameForUrl } from '../../../../services/category/utils';
import { buildPathPrefix } from '../../../../utils/directoryUtils';
import { getQueryParams, buildQueryString } from '../../../../utils/routeUtils';

import SortSelectComponent from './SortSelectComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import NumberDisplayComponent from './NumberDisplayComponent';
import CategorySelectComponent from './CategorySelectComponent';
import OfferTypeSelectComponent from './OfferTypeSelectComponent';

import './FilterComponent.scss';

class FilterComponent extends React.Component {
    state = {
        isReset: false // Ajout de l'état pour suivre la réinitialisation du bouton
    };

    buildPathPrefix = () =>
        buildPathPrefix(
            this.props.locale,
            this.props.isCodePromo,
            this.props.isOffline,
            this.props.isEbon,
            this.props.isAllOffers
        );

    componentDidMount() {
        // Vérifier l'URL lors du chargement initial
        this.checkURLReset();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            // Vérifier l'URL lors d'un changement d'URL
            this.checkURLReset();
        }
    }

    checkURLReset() {
        // Récupération du chemin d'accès de l'URL actuelle
        const { pathname } = this.props.location;

        // Définition des chemins qui entraîneront la réinitialisation du bouton
        const resetPaths = [
            `/${PATH.ALPHA_PATH}/:letter`, // Chemin avec une lettre spécifique
            `/${PATH.CATEGORY_PATH}/:categoryName-:categoryId`, // Chemin avec une catégorie spécifique
            `/${PATH.MOST_POPULAR_PATH}` // Chemin des plus populaires
        ];

        // Vérification si le chemin actuel correspond à l'un des chemins de réinitialisation
        const isReset = resetPaths.some(path => pathname.includes(path));

        // Mise à jour de l'état "isReset" en fonction du résultat de la vérification
        this.setState({ isReset });
    }

    /**
     * Click handler Button A-Z
     * Le paramètre sort pré-sélectionne le tri "Nom" à l'arrivée sur la vue
     * alphabétique (lu par SortSelectComponent au montage) ; les autres
     * paramètres (filtre par type d'offre...) sont conservés.
     */
    onClickBtTriAZ = e => {
        e.preventDefault();
        this.props.clearFilter('directory');
        const params = getQueryParams(this.props.location.search);
        params.sort = directoryService.constants.NOM_SORT.id;
        this.props.history.push({
            pathname: `${this.buildPathPrefix()}/${PATH.ALPHA_PATH}/${
                directoryService.constants.ABCBOOK_DEFAULT_LETTER
            }`,
            search: buildQueryString(params)
        });
    };

    /**
     * Change handler on Category select
     * La query string (?sort=...) est conservée pour garder le tri choisi
     * d'une catégorie à l'autre.
     * @param {Integer} id
     */
    onChangeCategory = id => {
        const { categories, history, location } = this.props;

        if (toInteger(id) > 0) {
            const category = categories.filter(curr => toInteger(curr.id) === toInteger(id))[0];

            // on change l'url pour qu'elle matche avec le choix de la catégorie
            // les dispatch pour changer le store se font dans componentWillReceiveProps d'AnnuairePage
            if (!isEmpty(category)) {
                history.push({
                    pathname: `${this.buildPathPrefix()}/${
                        PATH.CATEGORY_PATH
                    }/${formatCategoryNameForUrl(category.label)}-${category.id}`,
                    search: location.search
                });
            }

            this.props.filterPartnerOnCategory('directory', Number(category.id));
        } else {
            history.push({
                pathname: `${this.buildPathPrefix()}/${PATH.MOST_POPULAR_PATH}`,
                search: location.search
            });
            this.props.clearFilter('directory');
        }
    };

    render() {
        const {
            i18n,
            partners,
            isCodePromo,
            categories,
            categoryId,
            isOffline,
            isEbon
        } = this.props;
        const { isReset } = this.state;

        return (
            <form className="annuaire-filtre flex-container-h flex-center-alt">
                <NumberDisplayComponent partners={partners} isCodePromo={isCodePromo} />
                <div className="filtre-conteneur flex-container-h flex-center-alt">
                    {this.props.isAllOffers && <OfferTypeSelectComponent />}
                    <CategorySelectComponent
                        categories={categories}
                        categoryId={categoryId}
                        onChangeCategory={this.onChangeCategory}
                    />
                    <ButtonComponent
                        text={
                            <React.Fragment>
                                <span className="sr-only">{i18n.AZ_BUTTON_LABEL} </span>A-Z
                            </React.Fragment>
                        }
                        color="sixth"
                        onClick={this.onClickBtTriAZ}
                        cssClass={`bt-az ${isReset ? 'reset' : ''}`}
                    />
                    <SortSelectComponent
                        categories={categories}
                        isCodePromo={isCodePromo}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                </div>
            </form>
        );
    }
}

FilterComponent.propTypes = {
    partners: PropTypes.array,
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    isAllOffers: PropTypes.bool,
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number.isRequired
};

const mapDispatchToProps = {
    filterPartnerOnCategory,
    clearFilter
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY,
        locale: state.i18n.locale
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterComponent));



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/FilterComponent.js